// src/components/BackButton2.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const FixedBackButton = styled.button`
  position: fixed;
  top: 200px;
  left: 20px;
  z-index: 999;
  padding: 8px 16px;
  background-color: #ce8e04;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #d98a04;
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 480px) {
    top: 10px;
    left: 10px;
    font-size: 12px;
    padding: 6px 12px;
  }
`;

const BackButton2 = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <FixedBackButton onClick={handleBack}>
      ← Back
    </FixedBackButton>
  );
};

export default BackButton2;
